import { render, staticRenderFns } from "./FeedbackItemV2.vue?vue&type=template&id=b91c24fc&scoped=true&"
import script from "./FeedbackItemV2.vue?vue&type=script&lang=js&"
export * from "./FeedbackItemV2.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackItemV2.vue?vue&type=style&index=0&id=b91c24fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91c24fc",
  null
  
)

export default component.exports